// extracted by mini-css-extract-plugin
export var createdDate = "_n3-1";
export var divider = "_n3-2";
export var headerDivider = "_n3-3";
export var messagesCard = "_n3-0";
export var messagesContainer = "_n3-7";
export var messagesContainerWrapper = "_n3-4";
export var pointerCapturingButtonBoxes = "_n3-a";
export var showLeftPanelButton = "_n3-9";
export var showMoreButton = "_n3-c";
export var showMoreButtonContainer = "_n3-b";
export var summaryTitle = "_n3-6";
export var systemMessageCardWrapper = "_n3-d";
export var topButtons = "_n3-8";
export var withPadding = "_n3-5";